import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss'],
})
export class DynamicTableComponent implements OnInit {
  @Output() enterEvent = new EventEmitter<string>();
  @Output() changeStateEvent = new EventEmitter<string>();
  @Input() data: any[] = [];
  @Input() columns: any[] = [];
  @Input() title!: string;
  @Input() ruta!: string;
  @Input() filter!: boolean;
  @Input() filters = {
    startDate: '',
    endDate: '',
    type: 0,
    state: ''
  }
  @Output() filtersEvent = new EventEmitter<any>();
  public isOpen!: boolean;
  public page: number = 1;

  constructor(
    private router: Router,
    public _mapService: MapService
  ) {}

  ngOnInit() {
  }

  presentfilter(open: boolean) {
    this.isOpen = open;
  }
  open() {
    this.isOpen = !this.isOpen;
  }

  navigateRute(item) {
   const url = this.router.createUrlTree([this.ruta], { queryParams: item }).toString();
   window.open(url, '_blank');
    //this._mapService.setCenterMap(3.83682054333414, -73.66623460450256,18);
  }

  search($event: string) {
    this.page = 1;
    this.enterEvent.next($event);
  }

  setFilters(event){
    this.page = 1;
    this.filtersEvent.next(event)
  }

  changeState(event){
    this.changeStateEvent.next(event)
  }
}
